<template lang="pug">
  div
    b-form-row.align-items-center.justify-content-between.mb-3
      b-col.mb-2.mb-md-0(md="6", lg="5")
      // SEARCH INPUT
      b-col(md="6", lg="5")
        b-input-group#search-input
          b-form-input(placeholder="Buscar campaña", v-model="search", debounce="1000" type="search", @update="getCampaigns")
          b-input-group-append
            b-input-group-text
              search-icon.icon-md
    // TEMPLATES HEADERS
    b-form-row.mb-3.px-2.d-none.d-md-flex.justify-content-between
      b-col(md="2", v-for="field in fields", :key="field") {{field}}
    .text-center.mt-2(v-if="loading")
      b-spinner(variant="primary")
    empty-message(v-else-if="!campaigns.length", :message="search.length ? 'No hay coincidencias' : 'No hay campañas programadas'" )
    b-card.mb-1(v-for="(item, index) in campaigns", :key="index", body-class="p-2")
      b-form-row.align-items-center.text-center.text-md-left.text-sm.justify-content-between
        b-col(md="2" )
          WhatsappTemplatePreview(:components="getComponents(item)", :prev-id="item.template_data.template_name")
        b-col(md="2" )
          b-link.text-underline(v-if="item.file_url", :href="item.file_url") {{item.name}}
          div(v-else) {{item.name}}
          .text-danger.text-sm(v-if="item.error") Mensaje: {{item.error}}
        b-col(md="2")
          b-badge(pill, :variant="item.sourceVariant") {{item.source}}
        b-col(md="2" )
          calendar-icon.icon-md.mr-1
          span {{$moment(item.date).format("DD MMMM YYYY HH:mm")}}
        b-col(md="2" )
          b-button.b-0(variant="outline-secondary", block, size="sm" @click="cancelCampaign(item)")
            b-spinner.ml-1(small, v-if='canceling === item._id')
            span(v-else) Cancelar envío
    Pagination(:current-page="paginationCurrentPage", :has-next-page="v_paginationHasNextPage", :total-pages="v_paginationTotalPages", :loading="loading", @click="paginationPageChanged($event, 'getCampaigns')")
</template>

<script>
import Pagination from "@/components/Pagination";
import WhatsappTemplatePreview from "@/components/WhatsappTemplatePreview";
import { createNamespacedHelpers, mapActions } from 'vuex'

const broadcastController = createNamespacedHelpers('broadcast')
const templatesController = createNamespacedHelpers('message_template')

export default {
  name: "CampaignsScheduled",
  data () {
    return {
      loading: false,
      canceling: null,
      search: '',
      fields: [
        'Vista previa',
        'Nombre',
        'Fuente de envío',
        'Fecha',
        'Acciones'
      ]
    }
  },
  computed: {
    ...templatesController.mapState({
      message_templates: state => state.message_templates
    }),
    ...broadcastController.mapState({
      campaigns: state => state.campaigns.map(el => {
        const {template_data = {}, block_name} = el
        el.source = '-'
        el.sourceVariant = 'secondary'

        if(template_data.template_name) {
          el.source = template_data.template_name
          el.sourceVariant = 'soft-success'
        } else if (block_name) {
          el.source = block_name
          el.sourceVariant = 'soft-info'
        }

        return el
      })
    }),
  },
  methods: {
    ...mapActions([
      'broadcast/campaigns',
      'broadcast/cancel_campaign']),
    getCampaigns () {
      this.loading = true

      this['broadcast/campaigns']({
        account_id: this.$route.params.account_id,
        params: {
          status: 'scheduled',
          name: this.search,
          ...this.paginationParamsObject,
        },
        callback: res => {
          this.loading = false
          if (res.error) return this.$message.error(res.error)
          this.parsePaginationDataFromResponse(res)
        }
      })
    },
    cancelCampaign ({_id}) {
      this.canceling = _id

      this['broadcast/cancel_campaign']({
        campaign_id: _id,
        callback: res => {
          this.canceling = null
          if (res.error) return this.$message.error(res.error)

          this.$message.success("Broadcast cancelado")
        }
      })
    },
    getComponents ({template_data}) {
      if(!template_data.template_name) return  []

      const template = this.message_templates.find(el => el.name === template_data.template_name)
      if(!template) return  []

      return template.components
    }
  },
  mounted () {
    this.getCampaigns()
  },
  watch: {
    search() {
      this.resetPaginationData()
    },
  },
  components: {WhatsappTemplatePreview, Pagination}
}
</script>

<style lang="scss" scoped>
</style>
